var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dowload-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M10.5,19.6v-7.5c0-0.5,0.4-1,1-1s1,0.4,1,1v7.5l1.1-1.1c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L12.9,22 c-0.8,0.8-2,0.8-2.8,0L8,19.9c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0L10.5,19.6z M17.8,7.3c0,0,0.1,0,0.1,0 c3.3,0,5.9,2.6,5.9,5.9s-2.6,5.9-5.9,5.9c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c2.2,0,3.9-1.8,3.9-3.9s-1.8-3.9-3.9-3.9 c-0.3,0-0.5,0-0.8,0.1c-0.6,0.1-1.1-0.3-1.2-0.9c-0.2-2.9-2.5-5.1-5.4-5.1c-3,0-5.4,2.4-5.4,5.4c0,0.5,0.1,0.9,0.2,1.3 c0.1,0.5-0.2,1.1-0.8,1.2c-1.4,0.3-2.4,1.5-2.4,2.9c0,1.6,1.3,3,3,3c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-2.7,0-4.9-2.2-4.9-4.9 c0-2,1.2-3.8,3-4.5c0-0.3-0.1-0.6-0.1-0.9c0-4.1,3.3-7.4,7.4-7.4C14.1,1.4,17.1,3.9,17.8,7.3z",
    fill: "#43418E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud);
export default __webpack_public_path__ + "static/media/download-cloud.9b4e56d3e9decab583102a23b64b1c2b.svg";
export { ForwardRef as ReactComponent };